// =================================================================================================
// Sizing Guide
// =================================================================================================
 // console.log("TeeTurtle");

  // Full Sizing Guide Page
  var menFullSizingTable = document.getElementById("menFullSizingTable");
  var womenFullSizingTable = document.getElementById("womenFullSizingTable");
  var kidFullSizingTable = document.getElementById("kidFullSizingTable");
  var sweatshirtFullSizingTable = document.getElementById("sweatshirtFullSizingTable");
  
  function updateMenSizingPage () {
      var country = document.getElementById("mensDropdown").value;
      if (country === "US"){
          menFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>28</td><td>29</td><td>30.5</td><td>31</td><td>32</td><td>33</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>17.5</td><td>20</td><td>22</td><td>24</td><td>26</td><td>28</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>14</td><td>14.5</td><td>16</td><td>16.5</td><td>17.5</td><td>19</td></tr></table>";
      }else if(country === "UK/EU"){
          menFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>71.5</td><td>73.5</td><td>77.5</td><td>78</td><td>81.5</td><td>83.5</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>45</td><td>51</td><td>55.5</td><td>61</td><td>65.5</td><td>71</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>35</td><td>37</td><td>40.5</td><td>42</td><td>44</td><td>49</td></tr></table>";
      }
  }
  
  function updateWomenSizingPage () {
      var country = document.getElementById("womensDropdown").value;
      if (country === "US"){
          womenFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>24.5</td><td>24.5</td><td>25.5</td><td>26.5</td><td>27.5</td><td>29</td><td>31</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>16</td><td>18</td><td>19</td><td>21</td><td>23</td><td>24</td><td>27</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>9</td><td>9.5</td><td>10</td><td>11</td><td>12</td><td>12.5</td><td>13</td></tr></table>";
      }else if(country === "UK/EU"){
          womenFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>XS</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>62</td><td>62.5</td><td>65.5</td><td>67.5</td><td>70</td><td>73.5</td><td>78.5</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>40.5</td><td>45.5</td><td>47.5</td><td>53</td><td>58.5</td><td>61</td><td>68.5</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>23</td><td>25</td><td>25.5</td><td>28</td><td>30</td><td>32</td><td>33</td></tr></table>";
      }
  }
  
  function updateKidSizingPage () {
      var country = document.getElementById("kidsDropdown").value;
      if (country === "US"){
          kidFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>22</td><td>23</td><td>25</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>15</td><td>16.5</td><td>17.5</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>10</td><td>10.5</td><td>12</td></tr></table>";
      }else if(country === "UK/EU"){
          kidFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>55.5</td><td>58</td><td>63</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>38</td><td>42</td><td>45</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>25</td><td>27</td><td>30</td></tr></table>";
      }
  }
  
  function updateSweatshirtSizingPage () {
      var country = document.getElementById("sweatshirtDropdown").value;
      if (country === "US"){
          sweatshirtFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (in)</strong></td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td>32</td></tr><tr><td><strong>Chest Width (in)</strong></td><td>19.5</td><td>21.5</td><td>23.5</td><td>25.5</td><td>27.5</td><td>29.5</td></tr><tr><td><strong>Sleeve Length (in)</strong></td><td>24</td><td>24.5</td><td>25</td><td>25.5</td><td>26</td><td>26.5</td></tr></table>";
      }else if(country === "UK/EU"){
          sweatshirtFullSizingTable.innerHTML = "<table class='fullSizingTable'><tr><th>Sizes</th><th>S</th><th>M</th><th>L</th><th>XL</th><th>2XL</th><th>3XL</th></tr><tr><td><strong>Shirt Length (cm)</strong></td><td>68.5</td><td>71</td><td>74</td><td>76</td><td>79</td><td>81</td></tr><tr><td><strong>Chest Width (cm)</strong></td><td>49.5</td><td>54.5</td><td>60</td><td>65</td><td>70</td><td>75</td></tr><tr><td><strong>Sleeve Length (cm)</strong></td><td>61</td><td>62</td><td>63.5</td><td>65</td><td>66</td><td>67</td></tr></table>";
      }
  }
  
// =================================================================================================
// Back to Top Button
// =================================================================================================
  
  let scrollTopBtn = document.getElementById("scrollBtn");
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
  }
  
  function scrollFunction() {
    if (scrollTopBtn) {
      // When the user scrolls down 20px from the top of the document, show the button
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        scrollTopBtn.style.display = 'block';
      } else {
        scrollTopBtn.style.display = 'none';
      }
    }
  }

  window.onscroll = function() {
    scrollFunction();
  };

  window.onload = function() {
    scrollFunction();
  };

// =================================================================================================
// USD Currency
// =================================================================================================

const priceList = document.getElementsByClassName("price__current");

for(let i=0; i<priceList.length; i++){
    if(priceList[i].innerText.includes("USD")){
        priceList[i].innerText = priceList[i].innerText.slice(0,-4);
    }
}

// =================================================================================================
// product sticky Button
// =================================================================================================
  
 var offsetSticky = document.querySelector("product-info.product__info-container"); 
 var cartSticky = document.querySelector("sticky-atc-panel.sticky-atc-panel"); 
 if (offsetSticky != null && cartSticky != null) {
  window.onscroll = function() {productAddtocartSticky()};  
  function productAddtocartSticky() { 
      var sticky = offsetSticky.offsetTop + 400;  
    if (window.pageYOffset > sticky) {
      cartSticky.classList.add("is__active");  
    } 
    else {
      cartSticky.classList.remove("is__active");  
    } 
   }
  let scrollTopBtn = document.querySelector(".sticky__product_button .button--ouline");
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function (evt) {
       evt.preventDefault();
      offsetSticky.offsetTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
  } 
}

// ==================================start=jquey=code===============================//
 

$(document).ready(function(){
  
  $("details.mega-menu summary.list-menu__item").hover(function () {
    $(this).parents('details.mega-menu').attr('open', 'open');
}, 
 function () {
       // $(this).parents('details.mega-menu').removeAttr('open', 'open');
});
  
$(document).on("click",".footer-block--menu .footer-block__heading",function(evt){
  evt.preventDefault();
  $(this).toggleClass("is--active");
  $(this).parents(".footer-block--menu").find('.footer-block__details-content').toggleClass("is--active");
  // // $(".footer-block__details-content").removeClass("is--active"); $(".footer-block__details-content").hide();
  // $(this).parents(".footer-block--menu").find('.footer-block__details-content').show();
});

// ====product page js ============// 
  
  $(document).on("click",".product-form__input--pill input[type=radio] + label",function(){
    setTimeout(function() {
    var priceHtml = $('product-info .product_block_price').html();
    $('.product_price_title-mobilde .product_block_price').html(priceHtml);
   }, 2000);
});

  // ---------explore-more-Product-popup-----------// 
 $(document).on("click",".hasVariantMetaSlide_scroll span.view_explorePopup",function(){ 
    $(this).closest('.quick-add-modal__content').scrollTop(0);
    $(this).closest('.quick-add-modal__content').addClass('quickview_sizechart_open');
    $(document).find('.explore-variantPopup').show();  
    $(document).find('.explore-variantPopup').addClass('is--active');  
 });
  
 $(document).on("click",".explore-variantProduct span.close_explorePopup",function(){ 
    $(document).find('.explore-variantPopup').hide();  
    $(document).find('.explore-variantPopup').removeClass('is--active');  
   $(this).closest('.quick-add-modal__content').removeClass('quickview_sizechart_open');
});
  
 $(document).on("click",".explore-variantProduct .varProduct--wrapper",function(){  
    $(document).find('.explore-variantProduct .varProduct--wrapper').removeClass('has--active'); 
    $(this).addClass('has--active');
    $(document).find('label.product_variantType_image[for="'+$(this).attr('data-id')+'"]').click(); 
    $('.explore-variantPopup').removeClass('is--active').hide();
});
  
// ---------explore-more-Product-popup-----------// 
 $(document).on("click",".product-form__input span.view_sizeChartPopup",function(){ 

   var varaint_title_name = $('fieldset.product-form__inputpills-1 input[type=radio]:checked+label').attr('data-value');
   $('.sizechart_list').each(function(){
      var varaint_title = $(this).attr('data-variant-name');
      if(varaint_title == varaint_title_name){
        var table_data = $(this).find($('.table_data'));
        table_data.each(function(){
          var sizeoptionhtml = $(this).html();
          var sizeoptionname = $(this).attr('data-sizename');
          if(sizeoptionhtml != '' ){
            $('.left_list.list_style span[data-optionname="'+sizeoptionname+'"]').show();
          }else{
            $('.left_list.list_style span[data-optionname="'+sizeoptionname+'"]').hide();
          }
        });      
      }
    });
   
    var option_2_size = $('fieldset.product-form__inputpills-2 input[type=radio]:checked+label').attr('data-value');
    if(option_2_size == "Men's"){
      $('.top_bar_table .list_style span.mens_list label').click();
    }
   if(option_2_size == "Women's"){
      $('.top_bar_table .list_style span.women_list label').click();
    }
   if(option_2_size == "Kid's" || option_2_size == "Kid's Unisex" || option_2_size == "Kids'"){
      $('.top_bar_table .list_style span.kids_list label').click();   
    }
   if(option_2_size == "Unisex"){
      $('.top_bar_table .list_style span.unisex_list label').click();
    }
    $(this).closest('.quick-add-modal__content').scrollTop(0);
    $(this).closest('.quick-add-modal__content').addClass('quickview_sizechart_open');
    $(document).find('.sizingGuidePopup').show();  
    $(document).find('.sizingGuidePopup').addClass('is--active');  
 });
  
 $(document).on("click",".sizingGuidePopup-wrapper span.close_sizingGuidePopup",function(){ 
    $(document).find('.sizingGuidePopup').hide();  
    $(document).find('.sizingGuidePopup').removeClass('is--active'); 
    $(this).closest('.quick-add-modal__content').removeClass('quickview_sizechart_open');
});

  $(document).on("click","span.sizeGuide__ViewMore",function(event) { 
  event.preventDefault();
  var thisDataid = $(this).attr('data-id')
  $("#"+thisDataid).slideToggle(); 
  $('.sizingGuide-inner').addClass('open_box');
});

  var first_type = $('fieldset.js.product-form__input.product-form__input--pill.product-type input[type=radio]:checked').val();
  if(first_type){
   var varaint_title_name = $('fieldset.js.product-form__input.product-form__input--pill.product-type input[type=radio]:checked').attr('data-meta');
   if(varaint_title_name){
      $('.productVariant--grayBra').text(varaint_title_name);
      $('.productVariant--grayBra').show();
   }else{
      $('.productVariant--grayBra').hide();
   }

    var viewall_count = $('.itg_custom_box .product-form__inputpills-1 .itg_type_active').length;
    if(viewall_count > 1){
      $('.view_explorePopup').removeClass('view_explorePopup_hide');
    }else{
      $('.view_explorePopup').addClass('view_explorePopup_hide');
    }
    
    
    var varaint_type_name_select = $.trim($('.itg_custom_box .product-form__inputpills-1 input[type=radio]:checked').val());
    if(varaint_type_name_select){
         $('.thumbnail-slider ul li').removeClass('thumbnail_alt');
         $(document).find('.thumbnail-slider ul li').each(function() {
           
             var ths_alt = $.trim($(this).attr('data-alt'));
              if(ths_alt == varaint_type_name_select){
                $(this).show().addClass('thumbnail_alt');
              }else{
                $(this).hide();
              }
         });
         if ($(".thumbnail_alt").length > 0) {
           $(".thumbnail_alt:first img").click();
         }else{
           $('.thumbnail-slider ul li').show();
           $(".thumbnail-slider ul li:first img").click();
         }
       }

      $('.varProduct--wrapper').removeClass('has--active');
      if(varaint_type_name_select != ''){
        $(document).find('.variantProduct-grid__item').each(function() {
             var namevariant = $(this).attr('data-variant-name');
             if(namevariant == varaint_type_name_select){
               $(this).find('.varProduct--wrapper').addClass('has--active');
             }
         });
      }

    var variant_sizeChart_data = $('fieldset.js.product-form__input.product-form__input--pill.product-type input[type=radio]:checked+label').attr('data-sizedata');
     if(variant_sizeChart_data == 1){
       $('.view_sizeChartPopup').removeClass('size_chart_link');
     }else{
       $('.view_sizeChartPopup').addClass('size_chart_link');
     }
    
  }

var option_check = $('.product-form__inputpills-1 input[type=radio]:checked').val();
var count_options = '';
$('.product-form__inputpills-1 .product_variantType_image').each(function(){
  var title = $(this).find('.ctt-optionTitle').text();
  var check_sizechart = $(this).attr('data-sizedata');
  if(check_sizechart > 0){
    var des = $(this).find('.ctt-optionTitle').attr('data-title');
    if(title == option_check){
      count_options = 'active_option_name';
    }else{
      count_options = '';
    }
    if(title != ''){
      $("#sizeGuide__ViewMoreList").append('<li><span class="sizingGuide__variant '+count_options+'" data-title="'+title+'" data-des="'+des+'">'+title+'</span></li>');
    }
  }
});
  
$(document).on("click",".itg_custom_box .product_variantType_image",function(event) { 
  //event.preventDefault()
  var _this = $(this);
  setTimeout(function () {
   if(_this.prev('input').is(':checked')) { 
      var varaint_title_name = _this.find('.ctt-optionTitle').attr('data-title');
      if(varaint_title_name != ''){
        $('.productVariant--grayBra').text(varaint_title_name);
        $('.productVariant--grayBra').show();
      }else{
        $('.productVariant--grayBra').hide();
      }
     
       var varaint_type_name = $.trim(_this.find('.ctt-optionTitle').text());
       if(varaint_type_name){
         $('.thumbnail-slider ul li').removeClass('thumbnail_alt');
         $(document).find('.thumbnail-slider ul li').each(function() {
             var ths_alt = $.trim($(this).attr('data-alt'));
              if(ths_alt == varaint_type_name){
                $(this).show().addClass('thumbnail_alt');
              }else{
                $(this).hide();
              }
         });
         if ($(".thumbnail_alt").length > 0) {
           $(".thumbnail_alt:first img").click();
         }else{
           $('.thumbnail-slider ul li').show();
           $(".thumbnail-slider ul li:first img").click();
         }
       }

       

      var variant_name_option = _this.attr('data-value');
      $('.varProduct--wrapper').removeClass('has--active');
      if(variant_name_option != ''){
        $(document).find('.variantProduct-grid__item').each(function() {
             var namevariant = $(this).attr('data-variant-name');
             if(namevariant == variant_name_option){
               $(this).find('.varProduct--wrapper').addClass('has--active');
             }
         });
      }

      var option_check = $('.product-form__inputpills-1 input[type=radio]:checked').val();
      var count_options = '';
      $("#sizeGuide__ViewMoreList").html('');
      $('.product-form__inputpills-1 .product_variantType_image').each(function(){
        var check_sizechart = $(this).attr('data-sizedata');
       if(check_sizechart > 0){
          var title = $(this).find('.ctt-optionTitle').text();
          var des = $(this).find('.ctt-optionTitle').attr('data-title');
          if(title == option_check){
            count_options = 'active_option_name';
          }else{
            count_options = '';
          }
          if(title != ''){
            $("#sizeGuide__ViewMoreList").append('<li><span class="sizingGuide__variant '+count_options+'" data-title="'+title+'" data-des="'+des+'">'+title+'</span></li>');
          }
       }
      });

     var variant_sizeChart_data = _this.attr('data-sizedata');
     if(variant_sizeChart_data == 1){
       $('.view_sizeChartPopup').removeClass('size_chart_link');
     }else{
       $('.view_sizeChartPopup').addClass('size_chart_link');
     }
     
   }
  }, 500);
});


$(document).on("click",".itg_custom_box .product-form__inputpills-1 label",function(event) { 
  //event.preventDefault()
  var _this = $(this);
       var varaint_type_name = $(this).attr('data-value');
       if(varaint_type_name){
         $('.thumbnail-slider ul li').removeClass('thumbnail_alt');
         $(document).find('.thumbnail-slider ul li').each(function() {
             var ths_alt = $.trim($(this).attr('data-alt'));
              if(ths_alt == varaint_type_name){
                $(this).show().addClass('thumbnail_alt');
              }else{
                $(this).hide();
              }
         });
         if ($(".thumbnail_alt").length > 0) {
           $(".thumbnail_alt:first img").click();
         }else{
           $('.thumbnail-slider ul li').show();
           $(".thumbnail-slider ul li:first img").click();
         }
       }
});

$(document).on("click",".arrow_sizechart",function(event) { 
  var name = $(this).attr('data-name');
  if(name == 'prev'){
    $('.sizeGuide__ViewMoreList li .active_option_name').parent('li').prev('li').find('span').click();
  }else{
    //$('.top_bar_table .list_style.left_list span input:checked').parent().next('span').find('label').click();
    $('.sizeGuide__ViewMoreList li .active_option_name').parent('li').next('li').find('span').click();
  }
});
  
  
$(document).on("click",".sizingGuide-inner.open_box",function(event) {  
   $('.sizeGuide__ViewMoreList').slideUp();
   $(this).removeClass('open_box');
});

$(document).on("click",".popup_ovrl",function(event) {  
   $('.explore-variantPopup').removeClass('is--active').hide();
});

  
$(document).on("click",".sizingGuide__variant",function(event) {  
  $('.sizingGuide__variant').removeClass('active_option_name');
  $(this).addClass('active_option_name');
  var varaint_title_name = $(this).attr('data-title');
  
  // $('.product-form__inputpills-1 label').each(function(){
  //   var titlename = $(this).attr('data-value');
  //   if(titlename == varaint_title_name){
  //     $(this).click();
  //   }
  // });
  
  $('.left_list.list_style span').removeClass('active_sizechart_list');
  $('.sizechart_list').each(function(){
    var varaint_title = $(this).attr('data-variant-name');
    if(varaint_title == varaint_title_name){
      var table_data = $(this).find($('.table_data'));
      table_data.each(function(){
        var sizeoptionhtml = $(this).html();
        var sizeoptionname = $(this).attr('data-sizename');
        if(sizeoptionhtml != '' ){
          $('.left_list.list_style span[data-optionname="'+sizeoptionname+'"]').show().addClass('active_sizechart_list');
        }else{
          $('.left_list.list_style span[data-optionname="'+sizeoptionname+'"]').hide();
        }
      });      
    }
  });

  // var option_2_size = $('fieldset.product-form__inputpills-2 input[type=radio]:checked+label').attr('data-value');
  // if(option_2_size == "Men's"){
  //   $('.top_bar_table .list_style span.mens_list label').click();
  // }
  // if(option_2_size == "Women's"){
  //   $('.top_bar_table .list_style span.women_list label').click();
  // }
  // if(option_2_size == "Kid's" || option_2_size == "Kid's Unisex" || option_2_size == "Kids'"){
  //   $('.top_bar_table .list_style span.kids_list label').click();   
  // }
  // if(option_2_size == "Unisex"){
  //   $('.top_bar_table .list_style span.unisex_list label').click();
  // }

  setTimeout(function() {
    $(".active_sizechart_list label").eq(0).click();
  }, 500); 

});

$(document).on("click",".list_style span label",function(event) {   
  var varaint_title_name = $('.sizingGuide__variant.active_option_name').attr('data-title');
  var varaint_des = $('.sizingGuide__variant.active_option_name').attr('data-des');
  if(varaint_title_name != ''){
    setTimeout(function() {
    $('.sizechart_list').each(function(){
      var varaint_title = $(this).attr('data-variant-name');
      if(varaint_title == varaint_title_name){
        var option_size_name = $('.list_style span input[type="radio"]:checked').val();
        var option_in_cm = $('.list_style.right_list span input[type="radio"]:checked').val();
        //console.log(option_size_name+'---'+option_in_cm);
        var join_option = option_size_name+'-'+option_in_cm;
        var html_get = $(this).find('.table_data[data-option="' + join_option + '"]').html();
        if(html_get != ''){
          $('.table_box_sizechart').html('');
          $('.table_box_sizechart').html(html_get);
          $('.sizeGuide__ViewMoreList').hide();
          $('.sizingGuide_allTitle').text(varaint_title_name);
          $('.sizingGuide__Text').text(varaint_des);
        }else{
          $('.table_box_sizechart').html('');
          $('.sizeGuide__ViewMoreList').hide();
          $('.sizingGuide_allTitle').text(varaint_title_name);
          $('.sizingGuide__Text').text(varaint_des);
        }
        
      }
    });
    }, 1000);
  }
});

//product page load variant slider scroll js  
var countlable = document.querySelectorAll(".itg_custom_box .product-form__inputpills-1 label").length;
  if(countlable > 2){
    const devWidth = 135;
    let current_select_option = document.querySelector('.product-form__input--pill input[type=radio]:checked + label');
    let indexcount = current_select_option.dataset.indexcount;
    if(indexcount != ''){
      indexcount = indexcount - 1;
      let totleWidth = devWidth * indexcount;
      if(totleWidth != ''){
        var scrollableElement = document.querySelector(".itg_custom_box .product-form__inputpills-1");
        if (scrollableElement) {
          scrollableElement.scrollLeft += totleWidth;
        }
     }
    }
  }
  
// ====collection page js ============// 
  $(document).on("click","span.sort__icons",function(event) { 
  event.preventDefault();
  $("ul.collection-sort-list").slideToggle();
  // $(".collection-sort-list-select").slideToggle();
});
 
// $(document).on("click","ul.collection-sort-list a",function(event) { 
//    event.preventDefault();
//   var thisVal = $(this).data('value');
//    $("select.facet-filters__sort option").removeAttr('selected'); 
//    $(this).parents('.facet-filters__field').find("select.facet-filters__sort option").each(function(){ 
//     var optionval= $(this).val(); 
//      if (optionval == thisVal){     
//         $(this).attr('selected','selected');
       
//        $(this).parents('.facet-filters__field').find("select.facet-filters__sort").val(optionval).change();  
//      }
//   }); 
// });

  
   // $(document).on('click','.itg-load-more a',function(e){
   //          e.preventDefault(); var thisButton = $(this);
   //        // var thisButton = $('.itg-load-more a');
   //           thisButton.text('Loading..');
   //          var scrollURL = $(this).attr('href');
   //          var pageAll = parseInt(thisButton.data('value'));
   //          var pageCount = parseInt(thisButton.data('page')); 
   //          $.ajax({
   //            type: 'GET',
   //            url: scrollURL,
   //            beforeSend: function() { 
   //            },
   //            success: function(data) {
   //              thisButton.hide();
   //              var filteredData = $(data).find("#product-grid").html();
   //              var itgLoadMore = $(data).find(".itg-load-more").html();
   //              var itgfilter = $(data).find(".facets-container").html();
   //              $(document).find("#product-grid").append(filteredData);
   //               $(document).find(".facets-container").html(itgfilter); 
   //              $(document).find(".itg-load-more").html(itgLoadMore); 
   //              // thisButton.text('Load More').show();
   //              thisButton.text('Load More');
   //               if (pageAll = pageCount){
   //               thisButton.hide();
   //             } else {
   //               thisButton.show();
   //             }
   //            },
   //            dataType: "html"
   //          });
   //      });
 
  
// ====collection page best selling ============// 
var itg_itemcount = $('.itg_itemcount').length;
var itg_itemcount = 18 - itg_itemcount;
$(".itg_gird #product-grid li.grid__item").slice(0, itg_itemcount).show();
$('.itg_gird .itg-load-more').hide();

     $(document).on('click','.itg_custom_more',function(e){ 
    e.preventDefault();
    $(".itg_gird #product-grid li.grid__item:hidden")
      .slice(0, 18)
      .fadeIn("slow");
    if (
      $(".itg_gird #product-grid li.grid__item:hidden").length == 0 ||
      $(".itg_gird #product-grid li.grid__item").length == 0
    ) {
      $(".itg_custom_more").fadeOut("slow");
      $('.itg_gird .itg-load-more').show();
    }
  });
  
  $(document).scroll(function (e) {
  $('.itg_gird .itg_custom_more').show();
  });

  // itg js


     let fOpt = $('.product-form__inputpills-1 input[type=radio]:checked').val();
     $('fieldset.product-form__inputpills-2 label.itg_disable').addClass('its-disable');
     $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
     let sOpt = $('.product-form__inputpills-2 input[type=radio]:checked').val();
     $('select#get-var option').each(function(){
       var dataVal = $(this).data('title').split(' / ');
       if(dataVal[0] == fOpt){
         $(`label.itg_disable[data-value="${dataVal[1]}"]`).removeClass('its-disable');
         if($('.product-form__inputpills-3 input[type=radio]:checked').length){
           if(dataVal[1] == sOpt){
             $(`label.itg_disable[data-value="${dataVal[2]}"]`).removeClass('its-disable');
           }
         }
       }
     });
   $(document).on('change click','.product-form__input input',function() {
     let tLength = $('.product-form__inputpills-3').length;
     let sLength = $('.product-form__inputpills-2').length;
     if(tLength || sLength){
       let fOpt = $('.product-form__inputpills-1 input[type=radio]:checked').val();
       let sOpt = $('.product-form__inputpills-2 input[type=radio]:checked').val();
       let tOpt = '';
       let mainVal = '';
       if(tLength){
          tOpt = $('.product-form__inputpills-3 input[type=radio]:checked').val();
       }
       if($(this).parents('.product-form__inputpills-1')){
         $('fieldset.product-form__inputpills-2 label.itg_disable').addClass('its-disable');
         $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
         $('select#get-var option').each(function(){
           var dataVal = $(this).data('title');
           let fVal = dataVal.split(' / ')[0];
           if(fVal == fOpt){
             let sVal = dataVal.split(' / ')[1];
               $(`label.itg_disable[data-value="${sVal}"]`).removeClass('its-disable');
             let tVal = '';
              if(tLength){
               tVal = dataVal.split(' / ')[2];
               $(`label.itg_disable[data-value="${tVal}"]`).removeClass('its-disable');
               
              }
           }
         });
       }
       if($(this).parents('.product-form__inputpills-2') && tLength){
         $('fieldset.product-form__inputpills-3 label.itg_disable').addClass('its-disable');
         $('select#get-var option').each(function(){
           var dataVal = $(this).data('title');
           let sVal = dataVal.split(' / ')[1];
           if(sVal == sOpt){
             let tVal = dataVal.split(' / ')[2];
             $(`label.itg_disable[data-value="${tVal}"]`).removeClass('its-disable');
             
           }
         });
       }
     }

     if($(this).closest('.product-form__inputpills-1').length  > 0){
       if($('.product-form__inputpills-2').length > 0){
         $('.product-form__inputpills-2 label').removeClass('variant_click');
         $('.product-form__inputpills-2 label').each(function() {
           if ($(this).hasClass('its-disable')){
           }else{
             $(this).addClass('variant_click');
           }
         });
         $('.product-form__inputpills-2 .variant_click').eq(0).click();
       }
     }
   });
  
});


// =================================================================================================
// Conventions Catalog
// =================================================================================================

var currentLink = window.location.href;
var TeeTurtleHeader = document.getElementsByClassName("shopify-section-group-header-group");
var TeeTurtleFooter = document.getElementsByClassName("footer");


if(currentLink.slice(-19) === "conventions-catalog") {
    for(let x=0; x < TeeTurtleHeader.length; x++){
        TeeTurtleHeader[x].classList.add("hidden-content");
    }
    for(let y=0; y < TeeTurtleFooter.length; y++){
        TeeTurtleFooter[y].classList.add("hidden-content");
    }
}else if(currentLink.slice(-27) === "conventions-fandoms-catalog") {
    for(let x=0; x < TeeTurtleHeader.length; x++){
        TeeTurtleHeader[x].classList.add("hidden-content");
    }
    for(let y=0; y < TeeTurtleFooter.length; y++){
        TeeTurtleFooter[y].classList.add("hidden-content");
    }
}else{
    for(let x=0; x < TeeTurtleHeader.length; x++){
        TeeTurtleHeader[x].classList.remove("hidden-content");
    }
    for(let y=0; y < TeeTurtleFooter.length; y++){
        TeeTurtleFooter[y].classList.remove("hidden-content");
    }
}


// =================================================================================================
// New Tab Pages
// =================================================================================================


var socialLinks = document.getElementsByClassName("list-social__link");
for (let i = 0; i < socialLinks.length; i++) {
  socialLinks[i].setAttribute("target", "_blank");
}

var Plushiverse = document.getElementById("HeaderDrawer-check-out-our-new-plushiverse-website");
if (Plushiverse) {
    Plushiverse.setAttribute("target", "_blank");
}

var Plushiverse2 = document.getElementById("HeaderMenu-check-out-our-new-plushiverse-website");
if (Plushiverse2) {
    Plushiverse2.setAttribute("target", "_blank");
}

// =================================================================================================
// FAQ Images
// =================================================================================================

var cancelOrderFAQ = document.getElementById("CollapsibleAccordion-collapsible_row_eDDzFM-template--22590877172018__collapsible_content_z3jLAm");
var cancelOrderImg = document.createElement('img');
cancelOrderImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0754/7581/2658/files/change-order.png?v=1715111138");
cancelOrderImg.setAttribute("alt", "Cancel Order Instructions");
cancelOrderImg.setAttribute("style", "border: none;");
if (cancelOrderFAQ) {
    cancelOrderFAQ.appendChild(cancelOrderImg);
}

// =================================================================================================
// Uncapitalize "shirt"
// =================================================================================================

var filterLinks = document.getElementsByClassName("facet-checkbox__text");
for (let i = 0; i < filterLinks.length; i++) {
  if(filterLinks[i].innerText === "Premium Cotton T-shirt " || filterLinks[i].innerText === "Premium Cotton T-shirt" || filterLinks[i].innerText === "Premium Cotton T-Shirt " || filterLinks[i].innerText === "Premium Cotton T-Shirt"){
    filterLinks[i].setAttribute("style", "text-transform: none;")
  }
}




